import React from 'react';
import { Badge } from '../ui/badge';

const tones = {
  active: 'bg-emerald-100 text-emerald-800', assigned: 'bg-blue-100 text-blue-800',
  capitalized: 'bg-indigo-100 text-indigo-800', posted: 'bg-emerald-100 text-emerald-800',
  approved: 'bg-emerald-100 text-emerald-800', pending_approval: 'bg-amber-100 text-amber-800',
  pending_capitalization: 'bg-amber-100 text-amber-800', draft: 'bg-slate-100 text-slate-700',
  under_maintenance: 'bg-orange-100 text-orange-800', impaired: 'bg-red-100 text-red-800',
  disposed_sold: 'bg-slate-200 text-slate-800', written_off: 'bg-red-100 text-red-800',
  reversed: 'bg-rose-100 text-rose-800', completed: 'bg-emerald-100 text-emerald-800',
};

export default function AssetStatusBadge({ status }) {
  const text = String(status || 'unknown').replaceAll('_', ' ');
  return <Badge className={`${tones[status] || 'bg-slate-100 text-slate-700'} hover:${tones[status] || 'bg-slate-100'}`}>{text}</Badge>;
}
